(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');

    function relocate(section) {
      var slot = section.querySelector('[data-mobile-selectors-slot]');
      if (!slot) return;
      var selectors = section.querySelector('.product__form .product__selectors, .product__selectors__mobile-slot .product__selectors');
      if (!selectors) return;

      var originParent = selectors.parentNode;
      var originNextSibling = selectors.nextSibling;

      function apply() {
        if (mq.matches) {
          if (selectors.parentNode !== slot) {
            slot.appendChild(selectors);
          }
        } else {
          if (selectors.parentNode !== originParent) {
            originParent.insertBefore(selectors, originNextSibling);
          }
        }
      }

      apply();
      if (mq.addEventListener) {
        mq.addEventListener('change', apply);
      } else if (mq.addListener) {
        mq.addListener(apply);
      }
    }

    function init() {
      document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
        if (section.querySelector('[data-mobile-selectors-slot]')) {
          relocate(section);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-grid-text-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSquigglies() {
      document.querySelectorAll('.column__heading__squiggly').forEach(function (svg) {
        var path = svg.querySelector('.column__squiggly-path');
        if (!path) return;
        var length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;

        var heading = svg.closest('.column__heading');
        if (!heading) return;

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                heading.classList.add('is-drawn');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(heading);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSquigglies);
    } else {
      initSquigglies();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
